export default [
  {
    id: 0,
    name: 'Chicken Masala',
    description: 'Chicken tikka masala is a dish of chunks of roasted marinated chicken (chicken tikka) in a spiced curry sauce. The sauce is usually creamy and orange-coloured. There are multiple claims to its place of origin, including the Punjab region of the Indian subcontinent or Glasgow in Scotland. It is among the United Kingdom\'s most popular dishes, leading a government minister, Robin Cook, to claim in 2001 that it was "a true British national dish".',
    price: '9.99 USD',
    img: {
      src: 'static/0.jpg',
    },
  },
  {
    id: 1,
    name: 'Salată de boeuf (Beef salad)',
    description: 'Salată de boeuf is a traditional Romanian dish, generally served during all festive and special occasions. It is a combination of finely chopped beef (or sometimes chicken, or turkey breast) and root vegetables, folded in mayonnaise and finished with murături, pickled vegetable garnishes. It can be made vegetarian, too.',
    price: '8.99 USD',
    img: {
      src: 'static/1.jpg',
    },
  },
];



// WEBPACK FOOTER //
// ./src/dishes.js